import styled from 'react-emotion';
import online from './online.png';

export const OnlineWrapper = styled.article`
	background: url(${online}) 22px center no-repeat #CA372D;
	background-size: 44px 44px;
	font-size: 0.875rem;
	font-weight: bold;
	height: 6.4em;
	line-height: 1.6;
	padding-left: 88px;
	padding-right: 0.5em;
	position: relative;

	a {
		color: #fff;
		display: block;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
`

export const OnlineLabel = styled.div`
	padding-left: 1rem;
	padding-top: 0.5rem;
	position: relative;
	text-transform: uppercase;

	&:after {
		background: #fff;
		border-radius: 50%;
		content: "";
		display: block;
		height: 0.625rem;
		left: 0;
		position: absolute;
		top: 0.875rem;
		width: 0.625rem;
	}
`

export const OnlineTitle = styled.div`
	height: 3.2em;
	overflow: hidden;
`

export const ArticleWrapper = styled.article`
	padding: 0.75rem 0.75rem 0 0.75rem;

	&:last-child {
		padding-bottom: 0.75rem;
	}

	a {
		display: block;
		color: #333;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
`

export const ArticleImage = styled.img`
	float: left;
	margin-right: 0.75rem;
`

export const ArticleTitle = styled.div`
	font-size: 0.875rem;
	line-height: 1.6;
	height: 4.8em;
	overflow: hidden;
`
